import { Link, Route, Routes } from "react-router-dom";
import { LOCALES } from "@sakani/contracts";
import { useI18n } from "./i18n.tsx";
import { BookingPage } from "./pages/Booking.tsx";
import { HomePage } from "./pages/Home.tsx";
import { HostListing, HostPage } from "./pages/Host.tsx";
import { ListingPage } from "./pages/Listing.tsx";
import { Pattern } from "./ui/Pattern.tsx";

const LABEL = { fr: "FR", en: "EN", ar: "عربي" } as const;

export function App() {
  const { locale, setLocale, t } = useI18n();
  return (
    <div className="shell">
      <header className="top">
        <Link to="/" className="wordmark" aria-label="Sekani">sekani</Link>
        <nav className="langs" aria-label="Language">
          {LOCALES.map((l) => (
            <button key={l} className={l === locale ? "on" : ""} onClick={() => setLocale(l)} aria-pressed={l === locale}>{LABEL[l]}</button>
          ))}
        </nav>
      </header>
      <hr className="hr" />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/l/:id" element={<ListingPage />} />
          <Route path="/host" element={<HostPage />} />
          <Route path="/host/l/new" element={<HostListing />} />
          <Route path="/host/l/:id" element={<HostListing key={location.pathname} />} />
          <Route path="/b/:id" element={<BookingPage />} />
          <Route path="*" element={<div className="wrap section"><div className="note"><Pattern /><p className="h2">404</p><Link className="link" to="/">{t("back")}</Link></div></div>} />
        </Routes>
      </main>
      <footer className="foot">
        <div className="wrap">
          <span className="eyebrow">{t("tagline")} · <Link to="/host" className="link">{t("h.nav")}</Link></span>
          <div className="giant" aria-hidden="true">sekani</div>
          <div className="row eyebrow"><span>{t("foot.estd")}</span><span>Maroc · موريتانيا</span></div>
        </div>
      </footer>
    </div>
  );
}
